import { getSupportRecordUser } from "./getSupportRecordUser";
import { getUsersSummary } from "./getUsersSummary";
import { postSupportRecordUser } from "./postSupportRecordUser";

export const csegSupportApi = {
  getSupportRecordUser,
  getUsersSummary,
  postSupportRecordUser
};
